module.exports = __webpack_public_path__ + "media/images/emblems/Wil-blazon-0e9397ce8c9857481af8a820e901e1ed.svg";